const faqList = [
	{
		question: "Who can join GCAS Regina?",
		answer:
			"Everyone. GCAS is open to established Ghanaian-Canadian families, non-Ghanaian spouses, newcomers to Canada, and anyone in Saskatchewan with an interest in Ghanaian culture.",
	},
	{
		question: "Do I need to be Ghanaian to attend an event?",
		answer:
			"No. Our gatherings welcome friends of Ghana alongside the Ghanaian community. You don't need any prior connection to come out and join us.",
	},
	{
		question: "What kind of events does GCAS host?",
		answer:
			"Ghana Independence Day celebrations, the Kente Ball, the Canada Day BBQ and potluck, the End-of-Year party, cultural nights, and community information sessions throughout the year.",
	},
	{
		question: "How do I find out what's happening next?",
		answer:
			"Join us on WhatsApp, our main community channel for updates, or check the Events page for what's coming up.",
	},
	{
		question: "Where are events held?",
		answer:
			"At venues around Regina, including the 7 Oaks Hotel and the Mitakuyé Owâs'ā Centre, among other community spaces, depending on the gathering.",
	},
];

export default faqList;
